import { useContext } from "react";
import ActionContext from "../context/actionProvider";

const useCancelModal = () => {
  const { openCancelModal, setOpenCancelModal, previousPage, setPreviousPage } =
    useContext(ActionContext);

  return {
    openCancelModal,
    setOpenCancelModal,
    previousPage,
    setPreviousPage,
  };
};

export default useCancelModal;
